import { render, staticRenderFns } from "./BackgroundUpload.vue?vue&type=template&id=3db58c47&scoped=true&"
import script from "./BackgroundUpload.vue?vue&type=script&lang=js&"
export * from "./BackgroundUpload.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundUpload.vue?vue&type=style&index=0&id=3db58c47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db58c47",
  null
  
)

export default component.exports